import { http } from "../ConnectApi/ConnectApi";

export async function AccountInfoController() {
  

  try {
    const response = await http.get(`tftc/info`, {
      withCredentials: true
    });

    
    return response;
  } catch (error: any) {
    console.error('Error during register:', error.response?.data || error.message);
    throw error;
  }
}
